import { Group, Stack, Text } from '@mantine/core';

import classNames from './ChatMessageRenderer.module.css';
import { ChatMessage, ChatMessageStatus } from '@/types/runs.ts';

type props = {
  message: ChatMessage;
  index: number;
};

const ChatMessageRenderer = ({ message, index }: props) => {
  const bg =
    message.role === 'user'
      ? 'var(--velos-brand-blue)'
      : message.status === ChatMessageStatus.Completed
        ? '#F5F5F5'
        : 'transparent';

  return (
    <Stack
      style={{
        alignSelf: message.role === 'user' ? 'flex-end' : 'flex-start',
        backgroundColor: bg,
        borderRadius: 10,
        whiteSpace: 'pre-wrap',
        maxWidth: '80%',
        wordBreak: 'break-word', // Add this to force word breaks
        overflowWrap: 'break-word',
        marginTop: index === 0 ? '15px' : undefined,
      }}
      px={'md'}
      py={'xs'}
      // className={classNames.shimmerText}
    >
      {message.status === ChatMessageStatus.Completed ? (
        <Text
          fz={13}
          lh={1.3}
          c={message.role === 'user' ? 'white' : 'inherit'}
          // className={classNames.shimmerText}
        >
          {message.content}
        </Text>
      ) : (
        <Group>
          <Text
            fz={13}
            lh={1.3}
            c={message.role === 'user' ? 'white' : 'inherit'}
            className={classNames.shimmerText}
          >
            {message.status === ChatMessageStatus.RetrievingSteps && 'Reading...'}
            {message.status === ChatMessageStatus.RetrievingDatasets && 'Thinking...'}
            {message.status === ChatMessageStatus.GeneratingResponse &&
              'Almost there... about 10 seconds left'}
          </Text>
        </Group>
      )}
    </Stack>
  );
};

export default ChatMessageRenderer;
